import { render, staticRenderFns } from "./MoleculeEditionBillingAcademyProyects.vue?vue&type=template&id=b25d80da"
import script from "./MoleculeEditionBillingAcademyProyects.vue?vue&type=script&lang=js"
export * from "./MoleculeEditionBillingAcademyProyects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports